import { updateChannel } from "../../../../../actions/Utilities/Channel";
import { useMutation } from "react-query";

const useUpdateChannel = () => {
  return useMutation(updateChannel);
};
export default useUpdateChannel;
